/* src/app/pages/refinamiento/formmotivo/formmotivo.component.scss */
/*# sourceMappingURL=formmotivo.component.css.map */
